<template></template>

<script>
export default {
  name: "GetCodeForOpenId_tai",
  data() {
    return {
      appid: "",
    };
  },
  methods: {
    getCode: function () {
      var url = "https://open.weixin.qq.com/connect/oauth2/authorize?";
      var appid = "appid=" + encodeURIComponent(this.appid);
      var redirect_uri =
        "&redirect_uri=" + encodeURIComponent(window.location.href);
      var response_type = "&response_type=" + encodeURIComponent("code");
      //静默获取code
      var scope = "&scope=" + encodeURIComponent("snsapi_base");
      //需要用户授权获取code
      //var scope = "&scope=" + encodeURIComponent("snsapi_userinfo");
      var state = "&state=" + encodeURIComponent("123");
      var wechat_redirect = "#wechat_redirect";

      var targetUrl =
        url +
        appid +
        redirect_uri +
        response_type +
        scope +
        state +
        wechat_redirect;

      window.location.href = targetUrl;
      //window.location.replace(targetUrl);
    },
    checkCode: function () {
      var code = this.getUrlParam("code"); // 截取code
      console.log("code->" + code);
      if (code == "") {
        this.getCode();
      } else {
        sessionStorage.setItem("code", code);
        this.$router.go(-2);
      }
    },

    getUrlParam: function (variable) {
      var query = window.location.search.substring(1);
      console.log("url search param:" + query);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      return "";
    },
  },
  mounted: function () {
    console.log("mounted->");
    var len = history.length;
    console.log("History len->" + len);
    var appid = sessionStorage.getItem("appid");
    this.appid = appid;
    this.checkCode();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/taizhouBus/GetCodeForOpenId_tai.vue